import { UserOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  Divider,
  // Menu,
  Tooltip,
  Input,
  message,
  Modal,
  Row,
  Steps,
  Typography,
} from "antd";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { companyProfile } from "../../actions/companySettings";
import file_download from "../../assets/icons/file_download.png";
import { getBoolVal, hasAccess, objectToFormData } from "../../utils";
import { millify } from "../../config/helper";
import {
  expenseComments,
  expenseDetails,
  expenseFiles,
} from "./../../actions/expenses/expenses";
import {
  ReportsExpAddComments,
  reportsExpAddComments,
  reportsExpDetails,
  reportsExpHistory,
  UserReportLinkExp,
} from "./../../actions/reports/reports";
import PageHeader from "./../PageHeader";
import LinkExpensesToReport from "./LinkExpensesToReport";

import { MessageOutlined } from "@ant-design/icons";
import Close from "../../assets/icons/close.png";
import { downloadAndZip } from "../Common/DownloadAll";
import BaseCurrency from "../Common/BaseCurrency";
const { Title } = Typography;
const { Panel } = Collapse;
const { Step } = Steps;

message.config({
  maxCount: 3,
});

const formatCommentTimestamp = (createdAt) => {
  if (!createdAt) {
    return "-";
  }

  const parsedDate = moment(
    createdAt,
    [
      "DD-MM-YYYY,HH:mm:ss",
      "DD-MM-YYYY, HH:mm:ss",
      "DD-MM-YYYY HH:mm:ss",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601,
    ],
    true,
  );

  if (parsedDate.isValid()) {
    return parsedDate.format("DD-MM-YYYY, HH:mm:ss");
  }

  const fallbackDate = moment(createdAt);
  return fallbackDate.isValid()
    ? fallbackDate.format("DD-MM-YYYY, HH:mm:ss")
    : createdAt;
};

const ExpensesDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    location: { state: { expenseData = {} } = {} },
  } = history;
  const location = useLocation();
  const inputComment = React.useRef(null);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [transactionComments, setTransactionComments] = React.useState([]);
  const [reportsExpHistoryData, setReportsExpHistoryData] = React.useState([]);
  const [modalType, setModalType] = React.useState("");
  const [input, setInput] = React.useState("");
  const companySettingResponse = useSelector(
    (state) => state.companySetting.companySetting || {},
  );
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );
  const expCommentsResponse = useSelector(
    (state) => state.expenses.comments || {},
  );
  const reportsExpAddCommentsResponse = useSelector(
    (state) => state.reports.reportsExpAddComments || {},
  );
  const expenses_files = useSelector(
    (state) =>
      state.expenses.expenseFiles?.data?.response?.transaction?.files || [],
  );

  const reportsExpHistoryResponse = useSelector(
    (state) => state.reports.reportsExpHistory || {},
  );
  const userReportLinkExpResponse = useSelector(
    (state) => state.reports.userReportLinkExp || {},
  );

  React.useEffect(() => {
    if (expenseData.id) {
      getBoolVal(sessionStorage.getItem("is_admin"))
        ? dispatch(reportsExpDetails({ report_id: expenseData.id }))
        : dispatch(expenseDetails({ id: expenseData.id }));
      dispatch(expenseFiles({ id: expenseData.id }));
      dispatch(expenseComments({ transaction_id: expenseData.id }));
      dispatch(
        reportsExpHistory(
          { transaction_id: expenseData.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      reportsExpAddCommentsResponse;
    if (status) {
      handleCancel();
      dispatch({
        type: ReportsExpAddComments.RESET,
      });
      dispatch(expenseComments({ transaction_id: expenseData.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsExpAddCommentsResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      userReportLinkExpResponse;
    if (status) {
      handleCancel();
      dispatch({
        type: UserReportLinkExp.RESET,
      });
      history.push("/expenses");
    }
    if (status === false) {
      dispatch({
        type: UserReportLinkExp.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkExpResponse]);

  React.useEffect(() => {
    const { data: { response: { comments = [] } = {}, status = false } = {} } =
      expCommentsResponse;
    if (status) {
      setTransactionComments(comments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expCommentsResponse]);

  React.useEffect(() => {
    const { data: { response: { history = [] } = {}, status = false } = {} } =
      reportsExpHistoryResponse;
    if (status) {
      setReportsExpHistoryData(history);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsExpHistoryResponse]);

  React.useEffect(() => {
    const {
      data: {
        response: { company_setting: { company_id = "" } = {} } = {},
        status = false,
      } = {},
    } = companySettingResponse;
    if (status && company_id) {
      dispatch(companyProfile({ id: company_id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySettingResponse]);

  // function handleMenuClick(e) {
  //   switch (e.key) {
  //     case "3":
  //       // dispatch(reportsExportExcel({ id: reportData.id }));
  //       break;
  //     default:
  //   }
  // }

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleAddComment = (record) => {
    if (input && record.id) {
      dispatch(
        reportsExpAddComments(
          objectToFormData({
            body: input,
            transaction_id: record.id,
          }),
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      setInput("");
    }
  };

  const renderUnrepOption = () => {
    return (
      <>
        <LinkExpensesToReport expense_id={expenseData.id} />
      </>
    );
  };

  const renderModalData = (type) => {
    switch (type) {
      case "addUnrepExp":
        return renderUnrepOption();
      default:
        return "";
    }
  };

  const renderModalTitle = (type) => {
    switch (type) {
      case "addUnrepExp":
        return "Add Expense to Report";
      default:
        return "";
    }
  };

  const renderModalClass = (type) => {
    switch (type) {
      case "addUnrepExp":
        return "right-alinged-modal";
      default:
        return "";
    }
  };
  console.log({ expenses_files });
  return (
    <>
      <Modal
        title={renderModalTitle(modalType)}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={renderModalClass(modalType)}
      >
        {renderModalData(modalType)}
      </Modal>
      <div className="heading-div">
        {expenseData?.isFromExpense ? (
          <PageHeader
            title={`Expenses`}
            navigation={{
              Home: "/dashboard/",
              Expenses: "/expenses/",
            }}
          />
        ) : (
          <PageHeader
            title={`Reports`}
            navigation={{
              Home:
                hasAccess("dashboard", "read") ||
                hasAccess("dashboard", "write")
                  ? "/dashboard"
                  : "",
              Reports: "/reports/",
            }}
          />
        )}
      </div>
      <div className="content2Wrapper">
        <div className="flex-between">
          <div className="exp-title">
            <div className="d-flex mb1" style={{ alignItems: "center" }}>
              <Title level={5} style={{ marginBottom: 0 }}>
                {expenseData.merchant_name || ""}
              </Title>
              <span className={`ml1 status status_${expenseData?.status}`}>
                {expenseData?.status === "pending"
                  ? "Saved"
                  : expenseData?.status?.replace(/_/g, " ")}
              </span>
            </div>
            <p>Date and Time: {expenseData.created_at || ""}</p>
          </div>
          <div className="d-flex action-btns">
            {expenseData?.status === "pending" &&
              expenseData?.transaction_type === "debit" && (
                <Button
                  className="cancelButton"
                  onClick={() => {
                    history.push("/expense-add", {
                      isEdit: true,
                      id: expenseData?.id,
                      card_ref: expenseData?.card_reference_number,
                      files: expenses_files,
                    });
                  }}
                >
                  Edit
                </Button>
              )}
            {expenseData.purpose === "Company" ? (
              <>
                {expenseData?.transaction_type === "debit" &&
                !is_admin &&
                expenseData?.status !== "rejected" &&
                expenseData?.report_status !== "pending_approval" &&
                expenseData?.status !== "reimbursed" &&
                expenseData?.status !== "pending_reimbursement" ? (
                  <Button
                    className="primaryButton"
                    onClick={() => {
                      setIsModalVisible(true);
                      setModalType("addUnrepExp");
                    }}
                  >
                    {expenseData?.status === "pending" ? "Add to " : "Change "}
                    Report
                  </Button>
                ) : null}
              </>
            ) : null}
            {/* <Dropdown overlay={menu} placement="bottomRight"> */}
            {expenseData?.transaction_type === "debit" &&
              expenses_files?.length > 0 && (
                <button
                  className="more"
                  onClick={() => {
                    downloadAndZip(expenses_files?.map((ele) => ele.file));
                  }}
                >
                  <img src={file_download} width={14} alt="upload" />
                  &nbsp; Receipts
                </button>
              )}

            {/* </Dropdown> */}

            <span
              className="close cursor"
              onClick={() => {
                expenseData?.isFromExpense
                  ? history.push("/expenses/", {
                      status: location.state.status,
                    })
                  : history.push(
                      expenseData?.report_id
                        ? `/report-details/` + expenseData?.report_id
                        : "/reports/",
                    );
              }}
            >
              <img src={Close} width={20} alt={"close"} />
            </span>
          </div>
        </div>
        <Divider />
        <Row>
          <Col span={13}>
            <section className="expense-info">
              <div className="title-card text-center">
                {expenses_files?.length > 0
                  ? expenses_files?.map((ele) => (
                      <img
                        alt=""
                        src={ele?.file || ""}
                        width="70%"
                        className="mt1 mb1"
                      />
                    ))
                  : "No Document"}
              </div>
            </section>
          </Col>
          <Col span={10} offset={1} className="contentAreas">
            <section className="expense-info">
              <div className="title-card">
                <span>Amount</span>
                <h2>
                  <BaseCurrency /> {millify(expenseData.amount || "")}
                </h2>
                {/* <span>Amount in INR: Rs. 98,756 (1 USD = 1 INR)</span><br />/ */}
              </div>
            </section>
            <section className="expense-info mt1">
              <div className="title-card">
                <Row>
                  <Col span={10} className="boldHead">
                    <p>Category</p>
                    <p>Merchant</p>
                    <p>Report Name</p>
                    {expenseData?.custom_fields?.map((ele) => (
                      <p className="capitalize">
                        {ele.key?.replace(/_/g, " ")}
                      </p>
                    ))}
                  </Col>
                  <Col span={14}>
                    {console.log(expenseData?.report_title?.length)}
                    <p>
                      {expenseData?.category && /\S/.test(expenseData?.category)
                        ? expenseData?.category
                        : "-"}
                    </p>
                    <p>
                      {expenseData?.merchant_name &&
                      /\S/.test(expenseData?.merchant_name)
                        ? expenseData?.merchant_name
                        : "-"}
                    </p>
                    <Tooltip title={expenseData?.report_title}>
                      <p className="cursor">
                        {expenseData?.report_title &&
                        /\S/.test(expenseData?.report_title)
                          ? expenseData?.report_title?.length > 30
                            ? expenseData?.report_title?.substring(0, 30) +
                              ". . ."
                            : expenseData?.report_title
                          : "-"}
                      </p>
                    </Tooltip>
                    {expenseData?.custom_fields?.map((ele) => (
                      <p>{/\S/.test(ele.value) ? ele.value : "-"}</p>
                    ))}
                  </Col>
                </Row>
              </div>
            </section>
            <Collapse accordion>
              <Panel header="Comments" key="1">
                <div className="commentsSection">
                  <Steps
                    direction="vertical"
                    size="small"
                    current={transactionComments.length + 1 || 100}
                  >
                    {transactionComments &&
                      transactionComments.map((item) => (
                        <Step
                          key={item.id}
                          title={item.body}
                          description={
                            formatCommentTimestamp(item.created_at) +
                            ` | ` +
                            item.user_name
                          }
                          icon={<MessageOutlined />}
                        />
                      ))}
                  </Steps>
                </div>
                <Row>
                  <div className="addExpComment mt2">
                    <Input
                      placeholder="Enter Comment"
                      value={input}
                      onInput={(e) => setInput(e.target.value.trimStart())}
                    />
                    <Button
                      key="1"
                      className="formButton ml1"
                      onClick={() => handleAddComment(expenseData)}
                    >
                      Send
                    </Button>
                  </div>
                </Row>
              </Panel>
            </Collapse>
            <Collapse accordion>
              <Panel header="History" key="3">
                <div className="commentsSection mt2">
                  <Steps
                    direction="vertical"
                    size="small"
                    current={reportsExpHistoryData.length + 1 || 100}
                  >
                    {reportsExpHistoryData &&
                      reportsExpHistoryData.map(
                        ({ body, created_at, user_name, id, status }) => (
                          <Step
                            key={id}
                            title={body}
                            description={
                              created_at +
                              " | " +
                              user_name +
                              " | Action: " +
                              status
                            }
                            icon={<UserOutlined />}
                          />
                        ),
                      )}
                  </Steps>
                </div>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ExpensesDetails;
